module.exports = {"130631100":"望都镇","130631101":"固店镇","130631102":"贾村镇","130631103":"中韩庄镇","130631104":"寺庄镇","130631105":"赵庄镇","130631106":"高岭镇","130631202":"黑堡乡","130631400":"望都经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130631.json
// module id = 251
// module chunks = 0